export default "__VITE_ASSET__CUU4zImB__"